export default "__VITE_ASSET__BFDKtCK2__"